import LineChartCard from './lineChartCard.container';

export default LineChartCard;
